export function billingErrorMessage (error, fallback) {
  const data = error && error.response ? error.response.data : null
  const status = error && error.response ? error.response.status : null
  const billingStatus = data && data.billing_status

  if (status !== 402 && !billingStatus) {
    return (data && data.message) || fallback
  }

  const messages = {
    trial_expired: 'Seu período de teste terminou. Escolha um plano em Conta > Plano para voltar a usar a plataforma.',
    suspended: 'A assinatura deste workspace está suspensa. Regularize a conta em Conta > Plano para liberar o acesso.',
    cancelled: 'A assinatura deste workspace foi cancelada. Escolha um plano em Conta > Plano para reativar o acesso.',
    overdue: 'Há uma pendência de pagamento neste workspace. Regularize a conta em Conta > Plano para continuar.',
    payment_failed: 'O pagamento da assinatura não foi aprovado. Atualize o cartão em Conta > Cobrança para liberar o acesso.',
    pending_payment: 'A assinatura está aguardando confirmação de pagamento. Confira os dados em Conta > Cobrança.'
  }

  return messages[billingStatus] || (data && data.message) || 'A assinatura precisa de atenção. Acesse Conta > Plano para continuar usando a plataforma.'
}
